import { HandlerTimer } from "component/extra/HandlerTimer";
import { fabric } from "fabric";
import * as React from "react";
import { render } from "react-dom";
import { getParameterByName } from "util/RequestUtil";
import { asEs6Module } from "wasabi-common/lib/util/Functions";
import "./util/canvas/CanvasWithRegistry";

import asyncComponent from "./AsyncComponent";
import Request from "./data/source/Request";

export interface ApplicationProps {
  container: any;
  renderer: Promise<any>;
  options: any;
}

const timer = new HandlerTimer({
  handleTime: HandlerTimer.ONE_MINUTE,
});

timer.start();
export default class Application {
  public static readonly oneMinuteTimer = timer;

  public static build(props: ApplicationProps): Application {
    return new Application(props);
  }

  private constructor(props: ApplicationProps) {
    if (props.options.baseURL) {
      Request.setup({
        baseURL: props.options.baseURL,
      });
    }
    fabric.filterBackend = (fabric as any).initFilterBackend();
    this.render(props);
  }

  public render(props: ApplicationProps) {
    const URL = window.location.href;
    const CURRENT_URL = URL.match(/\#(?:access_token)\=([\S\s]*?)\&/);
    if (CURRENT_URL) {
      localStorage.setItem("ACCESS_TOKEN", CURRENT_URL[1]);
    }

    const GOOGLE_CODE = getParameterByName("code");
    if (GOOGLE_CODE) {
      localStorage.setItem("GOOGLE_CODE", GOOGLE_CODE);
    }

    const Component = asyncComponent(() => props.renderer.then((renderer: any) => asEs6Module(renderer)));
    render(<Component />, props.container);
  }
}
